<template>
  <div class="row mb-16">
    <div class="small-12 columns">
      <h1 class="mb-3">Job Listings</h1>
      <hr />
      <router-link
        class="border m-4 mb-0 p-2 px-12 rounded-full bg-green text-white font-bold no-underline"
        to="/job-listing"
      >
        Add Job
      </router-link>
      <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      siteURL: siteConfig.siteURL,
      tableConfig: [
        {
          header: { textContent: "Title", sortingParam: "title" },
          path: "title",
          classList: "w-3/2",
        },
        { header: { textContent: "Id" }, path: "id" },
        {
          header: {
            textContent: "Company",
            sortingParam: "company",
          },
          path: "company",
          type: "company",
        },
        {
          header: {
            textContent: "Posted On",
            sortingParam: "created_on",
          },
          path: "created_on",
          type: "date",
        },
        {
          header: {
            textContent: "Slug",
          },
          path: "slug",
        },
        {
          header: {
            textContent: "Location",
          },
          path: "location",
        },
        {
          header: {
            textContent: "Option",
          },
          path: "slug",
          type: "action",
          actionButtonText: "Edit",
          routePath: "/job-listing/:slug",
        },
      ],
    }
  },
  computed: {
    endpoint() {
      return `${siteConfig.siteURL}admin/jobpost`
    },
  },
}
</script>

<style lang="postcss"></style>
